export const FETCH_ACCOUNT = 'FETCH_ACCOUNT',
  FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS',
  FETCH_ACCOUNT_FAILURE = 'FETCH_ACCOUNT_FAILURE';

export const EDIT_ACCOUNT = 'EDIT_ACCOUNT';
export const EDIT_ACCOUNT_SUCCESS = 'EDIT_ACCOUNT_SUCCESS';
export const EDIT_ACCOUNT_FAILURE = 'EDIT_ACCOUNT_FAILURE';

export const EDIT_ACCOUNT_PHOTO = 'EDIT_ACCOUNT_PHOTO';
export const EDIT_ACCOUNT_PHOTO_SUCCESS = 'EDIT_ACCOUNT_PHOTO_SUCCESS';
export const EDIT_ACCOUNT_PHOTO_FAILURE = 'EDIT_ACCOUNT_FAILURE';



// WEBPACK FOOTER //
// ./src/views/account/_types.js